import React, { useEffect, useState } from "react";
import cn from "classnames";
import { func } from "../../../utils";
import Text from "../Text";
import PropTypes from "prop-types";
import Button from "../Button";
import { useLocation, useNavigate } from "react-router-dom";
import { isLiveStreamingDate, scrollTo } from "../../../utils/function";
import {
  usePageContextFunction,
  usePageContextState,
} from "../../../context/PageContext";
import analytics from "../../../utils/analytics";
import useWindowSize from "../../../hooks/useWindowSize";
import { useStore } from "zustand";
import { useUserData } from "../../../store/user";
import { useFetchCurrentRegistrationData } from "../../../networks";
import { useURLParams } from "../../../hooks/useURLParams";

const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/featured-images/`;

const NavBar = ({ menus, className, pageType, isShowBurger = true }) => {
  const { size } = useWindowSize();
  const { buildURLWithParams } = useURLParams();
  const isUserRegisteredPage = pageType === "registered-user";
  console.log({ pageType });
  const isSmallScreen = (size?.height || 0) <= 667;
  const isMobileView = (size?.width || 0) <= 768;
  const [offset, setOffset] = useState(0);
  const [offset2, setOffset2] = useState(0);
  const [navBlur, setNavBlur] = useState(false);
  const [showNavigationMenu, setShowNavigationMenu] = useState(false);
  const [isHomeDetailScrolled, setIsHomeDetailScrolled] = useState(false);
  const { city, idInView, isRegist, registrationUrl } =
    usePageContextState();

  const { registrationData, setRegistrationData } = useUserData();
  const { setIdInView } = usePageContextFunction();
  const navigate = useNavigate();
  const location = useLocation();
  const { accessToken } = useUserData();
  const isSubMenu = location.pathname?.split("/")?.length > 2;
  // Home-details scrolls inside #root (its overflow-x:hidden makes overflow-y
  // compute to `auto`), not the window — so `offset`/isNavOffset stay 0 and the
  // window-driven blur never fired. Detect the page here so we can mirror #root's
  // scroll instead. Scoped to the city home-details page (single-segment path,
  // not press-con / soc / registered-user / sub-page).
  const isHomeDetailPage =
    !!city &&
    city !== "press-con" &&
    city !== "soc" &&
    !isUserRegisteredPage &&
    !isSubMenu;
  const eventCategoryId = registrationData?.event_category_id;
  const isDanceCategory = eventCategoryId === 3;
  const imgLogo = isDanceCategory
    ? func.getStaticImg("illustration/piala-byU-2025.png")
    : `${imgPath}${registrationData?.school_logo}`;

  const sections = document.querySelectorAll("section");
  const navLi = document.querySelectorAll(".navbar__container__inner__text");
  const isNavOffset = offset > 0;
  const navOffSetExclusion = idInView === "hall-of-fame" && isNavOffset;
  const isSocSection = city === "soc" || idInView === "rsvp" || city;
  const rootUrl =
    idInView === "rsvp"
      ? "https://pialabyu.com/rsvp"
      : city && city !== "press-con"
        ? `https://pialabyu.com/${city}`
        : "https://pialabyu.com";
  const classNames = cn("navbar__container", className, {
    navbar__container__scroll:
      (idInView !== "slick-scroll" && isNavOffset) ||
      (idInView === "footer-landing" && isSocSection),
    navbar__container__scroll__dynamicHighlight: navOffSetExclusion,
    "!z-[20]": isUserRegisteredPage,
  });

  const footerLandingId = !isSocSection
    ? "footer-landing"
    : "footer-landing-soc";
  const infoLokasiId = !isSocSection ? "info-lokasi" : "info-lokasi-soc";
  const classNamesBurger = cn("navbar__burger-menu__bar", {
    // "navbar__burger-menu__bar__solid":
    //   [
    //     "event",
    //     footerLandingId,
    //     "journey",
    //     "jadwal-pertandingan",
    //     "klasemen-pertandingan",
    //     infoLokasiId,

    //     "sponsor",
    //   ].includes(idInView) && !isNavOffset,
    "navbar__burger-menu__bar__solid-black":
      ["event", footerLandingId, "journey", "sponsor"].includes(idInView) ||
      (isNavOffset &&
        idInView !== "hall-of-fame" &&
        infoLokasiId !== "info-lokasi-soc") ||
      isUserRegisteredPage,
    "navbar__burger-menu__bar__onOpen": showNavigationMenu,
  });

  const classNamesNavbar = cn(
    "navbar__container__inner",
    {
      navbar__container__inner__shadow:
        location.pathname === "/" &&
        location.pathname === "/pembayaran" &&
        [footerLandingId, "journey"].includes(idInView),
    },
    "md:pr-[2vw] md:pl-[10vw] pr-[2vw] pl-[5vw]",
  );

  const { pathname } = useLocation();
  const isLoginPage = pathname.includes("login");
  const isGalleryPage = pathname.includes("gallery");
  const isLogin = !!accessToken;

  // registrationData is normally populated only by HomeUser, so the school
  // logo/name are blank on pages that never mount it. Fetch it here (when logged
  // in and not already loaded) so it's available in the navbar everywhere.
  const hasRegistrationData = !!registrationData?.id;
  const { data: registrationDataRaw } = useFetchCurrentRegistrationData(
    isLogin && !hasRegistrationData,
  );
  useEffect(() => {
    const registration = registrationDataRaw?.data?.data?.registration;
    if (registration && !hasRegistrationData) {
      setRegistrationData(registration);
    }
  }, [registrationDataRaw]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const onScroll = () => setOffset(window.pageYOffset);
    // clean up code
    window.removeEventListener("scroll", onScroll);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // RSVP scrolls inside the Layout container (not the window), so mirror its
  // scrollTop into `offset` — this makes the navbar stick + blur on scroll down.
  useEffect(() => {
    if (idInView !== "rsvp") return;
    const el = document.querySelector(".rsvp-scroll");
    if (!el) return;
    const onScroll = () => setOffset(el.scrollTop);
    onScroll();
    el.addEventListener("scroll", onScroll, { passive: true });
    return () => el.removeEventListener("scroll", onScroll);
  }, [idInView]);

  // Home-details scrolls inside #root (window offset stays 0), so blur off the
  // scroll container's scrollTop — this triggers the blur the moment we leave
  // the very top, not only when a lower section crosses the center line.
  useEffect(() => {
    if (!isHomeDetailPage) return;
    const el = document.getElementById("root");
    if (!el) return;
    const onScroll = () => setIsHomeDetailScrolled(el.scrollTop > 0);
    onScroll();
    el.addEventListener("scroll", onScroll, { passive: true });
    return () => el.removeEventListener("scroll", onScroll);
  }, [isHomeDetailPage]);

  useEffect(() => {
    const rootBody = document.getElementById("root-body");
    if (city === "soc" || city === "press-con") {
      rootBody.style.backgroundColor = "#2e4261";
    } else {
      rootBody.style.backgroundColor = ""; // Reset to default
    }
  }, [city]);
  useEffect(() => {
    document.querySelector(".box-wrapper")?.addEventListener(
      "scroll",
      (e) => {
        if (
          (idInView === "timeline-soc" ||
            idInView === "hall-of-fame" ||
            idInView === "sponsor-soc" ||
            idInView === "footer-landing" ||
            infoLokasiId === "info-lokasi-soc") &&
          isMobileView
        ) {
          let st = Math.ceil(e.currentTarget.scrollTop * 100) / 100;
          //console.log({ st, offset2: offset2 + 0.5 });
          if (st === offset2 + 0.5) {
            setNavBlur(false);
            // downscroll code
          } else {
            setNavBlur(true);
          } // else was horizontal scroll
          setOffset2(st <= 0 ? 0 : st);

          //  const scrollPosition = e.currentTarget.scrollTop;

          // if (offset <= Math.round(scrollPosition * 100) / 100 && !navBlur) {
          //   setNavBlur(true);
          //   setOffset(
          //     Math.round(scrollPosition * 100) / 100 -
          //       Math.round(window.innerHeight)
          //   );
          // } else if (offset > Math.round(scrollPosition * 100) / 100) {
          //   setNavBlur(false);
          // }
        } else {
          setNavBlur(false);
          setOffset2(0);
        }
      },
      false,
    );
  }, [idInView, offset2]);

  useEffect(() => {
    // showNavigationMenu (Mobile Menu)

    if (showNavigationMenu) {
      document.body.classList.add("show-navigation");
      document.body.classList.add("rm-scroll");
    } else {
      document.body.classList.remove("show-navigation");
      document.body.classList.remove("rm-scroll");
    }
  }, [showNavigationMenu]);
  // window.onscroll = () => {
  //   let current = "";
  //   sections.forEach((section) => {
  //     const sectionTop = section.offsetTop;
  //     const sectionHeight = section.offsetHeight;

  //     if (window.pageYOffset >= sectionTop - sectionHeight / 2) {
  //       current = section.getAttribute("id");
  //     }
  //   });

  //   navLi.forEach((div) => {
  //     div.classList.remove("navbar__container__inner__text__active");

  //     if (div.classList.contains(current)) {
  //       div.classList.add("navbar__container__inner__text__active");
  //     }
  //   });
  // };
  const handleNavigationMenu = () => {
    setShowNavigationMenu(!showNavigationMenu);
  };

  // No blur at the very top of the hero; blur as soon as the page is scrolled
  // off the top (driven by #root's scrollTop, mirrored above).
  const homeDetailBlur = isHomeDetailPage && isHomeDetailScrolled;
  console.log({ idInView });
  const getStyles = () => {
    // if (isSubMenu && !location.pathname.includes("info-lomba")) {
    //   return {
    //     backgroundColor: "#00BCF1",
    //     imgByu: func.getStaticImg(`illustration/byU-logo.svg`),
    //   };
    // }

    if (
      (idInView === "event" ||
        idInView === footerLandingId ||
        idInView === "journey" ||
        idInView === "timeline" ||
        idInView === "sponsor" ||
        isNavOffset) &&
      idInView !== "hall-of-fame"
    ) {
      const offCond =
        (idInView === "event" ||
          idInView === footerLandingId ||
          idInView === "sponsor" ||
          isNavOffset) &&
        !navBlur &&
        infoLokasiId !== "info-lokasi-soc";
      return {
        backgroundColor: offCond ? "white" : "#0397C9",
        imgByu: func.getStaticImg(
          offCond
            ? "illustration/byu-logo-blue.svg"
            : `illustration/byU-logo.svg`,
        ),
        position: idInView === "timeline" ? "absolute" : "inherit",
        loginbtn: "primary-white",
        iconLogin: isMobileView ? "white" : "black",
        invertNavbar: offCond && !isMobileView,
        burgerMenuClassName: classNamesBurger,
      };
    } else if (
      idInView?.includes("jadwal-pertandingan") ||
      idInView?.includes("klasemen-pertandingan") ||
      idInView?.includes("info-lokasi")
    ) {
      const isSocNav =
        isMobileView && idInView == "info-lokasi" && city === "soc";

      return {
        backgroundColor: "transparent",
        burgerMenuClassName: classNamesBurger,
        imgByu: func.getStaticImg(
          isNavOffset || infoLokasiId === "info-lokasi-soc"
            ? `illustration/byU-logo.svg`
            : `illustration/byu-logo-blue.svg`,
        ),
        position: infoLokasiId === "info-lokasi-soc" ? "relative" : "inherit",
        invertNavbar: city ? false : !isMobileView,
        loginbtn: "primary-white",
        iconLogin: isMobileView ? "white" : "black",
      };
    } else {
      return {
        backgroundColor: "transparent",
        imgByu: func.getStaticImg(`illustration/byU-logo.svg`),
        burgerMenuClassName: classNamesBurger,
        position: "absolute",
        loginbtn: "secondary-white",
        iconLogin: "white",
        //   invertNavbar: true,
      };
    }
  };

  const renderNav = () => {
    return (
      <div className="o-header__nav hideOnMobile">
        <ul
          className="o-header__menu"
          style={{
            display: "inline-flex",
            alignItems: "center",
            marginLeft: "2.4rem",
            marginBottom: "1rem",
          }}
        >
          {menus.map((menu, idx) => {
            const exclutionConditional =
              (menu?.link === "perjalanan-pialabyu" && idInView === "event") ||
              (menu?.link === "announce" && idInView === "banner");

            const isPageActive =
              pageType === "landing-page" ||
              (pageType === "press-con" && city === "press-con")
                ? menu?.link === idInView || exclutionConditional
                : menu?.link === location.pathname;

            const classNameNavItem = cn(
              "navbar__container__inner__text",

              menu?.link,
              {
                // navbar__container__inner__text__active: false,
                navbar__container__inner__text__active:
                  isPageActive && !getStyles()?.invertNavbar,
                navbar__container__inner__text__invert:
                  isPageActive && getStyles()?.invertNavbar,
              },
            );

            return (
              <span
                key={`mmi-${idx}`}
                className={"navbar__menu__item"}
                style={{ margin: "0px 16px 0px 16px" }}
                onClick={async () => {
                  analytics.sendEvent({
                    event: "maintab_pialabyu",
                    title: menu?.label,
                  });
                  if (
                    pageType === "landing-page" ||
                    (pageType === "press-con" && city === "press-con")
                  ) {
                    if (menu?.link === "announce") {
                      // press-con names its hero section "banner", not
                      // "announce" — fall back so this doesn't throw on null.
                      const element =
                        document.getElementById("announce") ||
                        document.getElementById("banner");
                      element?.scrollIntoView(false);
                    } else {
                      if (
                        menu?.link !== "footer-landing" &&
                        !menu?.anotherPage
                      ) {
                        await setIdInView(menu?.link);
                      } else {
                        if (menu?.anotherPage) {
                          navigate(buildURLWithParams(menu?.link ?? "/"));
                        }
                      }
                      func.scrollTo(menu?.link);
                    }
                  } else {
                    if (menu?.link === "external") {
                      menu?.onClick?.();
                    } else {
                      console.log("menu", menu?.link);
                      navigate(buildURLWithParams(menu?.link ?? "/"));
                    }
                  }
                  setShowNavigationMenu(false);
                }}
              >
                {/* <Link href={menu?.link}> */}
                <a
                  //  href={menu?.link}
                  className="navbar__menu__link"
                  style={{ textDecoration: "none" }}
                >
                  <Text
                    className={classNameNavItem}
                    weight="bold"
                    size="medium"
                    color={getStyles()?.invertNavbar ? "primary" : "white"}
                  >
                    {menu?.label}
                  </Text>
                </a>
                {/* </Link> */}
              </span>
            );
          })}
        </ul>
      </div>
    );
  };
  console.log({ city });
  return (
    <>
      <div
        className={cn(
          classNames,
          (navBlur && isMobileView && idInView !== "banner") ||
            (idInView === "info-lokasi" &&
              infoLokasiId === "info-lokasi-soc" &&
              idInView !== "banner") ||
            ((city === "press-con" || city) && offset) ||
            // Press-con scrolls inside .box-wrapper, so `offset` (window/rsvp
            // based) never updates and the line above never fires. Blur whenever
            // scrolled off the hero, on desktop too. Driven by idInView, not
            // offset, so isNavOffset stays put and the logo/menu/burger keep
            // their light state on the navy blur.
            (city === "press-con" && idInView !== "banner") ||
            homeDetailBlur ||
            ((idInView === "jadwal-pertandingan" ||
              idInView === "klasemen-pertandingan") &&
              idInView !== "banner") ||
            (idInView === "footer-landing" && isSocSection)
            ? "!bg-[#1f2d3d60] bg-blur-md top-0 !z-[100]"
            : idInView === "rsvp"
              ? offset > 0
                ? "!bg-[#1f2d3d60] bg-blur-md top-0 !z-[100]"
                : " top-0"
              : isMobileView && !navBlur && infoLokasiId === "info-lokasi-soc"
                ? "!bg-transparent"
                : "",
        )}
        style={
          isUserRegisteredPage
            ? {
                height: 64,
                top: 0,
                backgroundColor: "white",
              }
            : offset <= 0
              ? {
                  position: getStyles()?.position,
                  height: 64,
                  background: getStyles()?.background,
                  backgroundRepeat: getStyles()?.backgroundRepeat,
                  backgroundColor: isLogin
                    ? "transparent"
                    : getStyles()?.backgroundColor,
                  top:
                    idInView === "banner" ||
                    idInView === "timeline-presscon" ||
                    idInView !== "banner-section2" ||
                    idInView === "home-detail-banner" ||
                    idInView === "home-detail-content" ||
                    idInView === "home-detail-content-01" ||
                    idInView === "home-detail-content-02" ||
                    idInView === "banner-section2"
                      ? isMobileView
                        ? 25
                        : 30
                      : getStyles()?.backgroundColor !== "transparent"
                        ? 0
                        : 0,
                  // height: isSmallScreen ? 64 : 88,
                }
              : { height: 64 }
        }
      >
        {isLoginPage ? (
          <div className={classNamesNavbar}>
            <img
              className={"navbar__container__m-button--icon"}
              src={func.getStaticImg(`icon/sa-arrow-left.svg`)}
              alt={"login-icon"}
              height={24}
              width={24}
              onClick={() => navigate(-1)}
            />
          </div>
        ) : (
          <div className={classNamesNavbar}>
            {isLogin && showNavigationMenu ? (
              <div
                className={`z-[12] flex items-center gap-2  transition-opacity ease-in duration-700 ${
                  showNavigationMenu ? "opacity-100" : "opacity-0"
                }`}
              >
                <img
                  src={imgLogo}
                  alt={`school-logo`}
                  onClick={() =>
                    navigate(city === "soc" ? buildURLWithParams("/") : "/")
                  }
                  className={`w-auto h-[28px] navbar__container__byu-logo transition-opacity ease-in duration-700 ${
                    showNavigationMenu ? "opacity-100" : "opacity-0"
                  }`}
                />
                <span
                  className={`text-white font-bold text-[16px]  transition-opacity ease-in duration-700 ${
                    showNavigationMenu ? "opacity-100" : "opacity-0"
                  }`}
                >
                  {registrationData?.school_name || "-"}
                </span>
              </div>
            ) : (location.pathname !== "/" &&
                location.pathname !== "/pembayaran") ||
              (location.pathname !== "/main" && !isLogin) ? (
              <img
                onClick={() => {
                  analytics.sendEvent({
                    event: "maintab_pialabyu",
                    title: "byU",
                  });
                  window.location.href = rootUrl;
                }}
                src={getStyles()?.imgByu}
                alt={`byU-logo`}
                className={`navbar__container__byu-logo`}
              />
            ) : null}

            <div
              className={cn(
                "navbar__container__inner__wrapper--text navbar__nav",
                isSocSection ? "bg-[#1F2D3D] h-[100vh]" : "",
              )}
            >
              <div className="navbar__menu-list">
                {menus.map((menu, i) => {
                  const exclutionConditional =
                    (menu?.link === "perjalanan-pialabyu" &&
                      idInView === "event") ||
                    (menu?.link === "announce" && idInView === "banner");
                  const isPageActive =
                    pageType === "landing-page" ||
                    (pageType === "press-con" && city === "press-con")
                      ? menu?.link === idInView || exclutionConditional
                      : menu?.link === location.pathname;
                  const classNameNavItem = cn(
                    "navbar__container__inner__text",
                    "navbar__link",
                    "navbar__item",
                    menu?.link,
                    {
                      // navbar__container__inner__text__active: false,
                      navbar__container__inner__text__active:
                        isPageActive && !getStyles()?.invertNavbar,
                      navbar__container__inner__text__invert:
                        isPageActive && getStyles()?.invertNavbar,
                    },
                  );

                  if (menu?.hideMenu) return;

                  return (
                    <span
                      key={i}
                      onClick={async () => {
                        analytics.sendEvent({
                          event: "maintab_pialabyu",
                          title: menu?.label,
                        });

                        const whiteListedNav = ["landing-page", "press-con"];
                        console.log({ pageType, city });
                        if (whiteListedNav?.includes(pageType)) {
                          if (menu?.link === "announce") {
                            // press-con names its hero section "banner", not
                            // "announce" — fall back so this doesn't throw on null.
                            const element =
                              document.getElementById("announce") ||
                              document.getElementById("banner");
                            element?.scrollIntoView(false);
                          } else {
                            if (
                              menu?.link !== "footer-landing" &&
                              !menu?.anotherPage
                            ) {
                              city === "press-con"
                                ? await setIdInView(menu?.link)
                                : navigate(
                                    buildURLWithParams(menu?.link ?? "/"),
                                  );
                            } else {
                              if (menu?.anotherPage) {
                                navigate(buildURLWithParams(menu?.link ?? "/"));
                              }
                              func.scrollTo(menu?.link);
                            }
                            func.scrollTo(menu?.link);
                          }
                        } else if (menu?.link === "external") {
                          menu?.onClick?.();
                        } else {
                          navigate(buildURLWithParams(menu?.link ?? "/"));
                        }
                        // navigate(menu?.link ?? "/");

                        setShowNavigationMenu(false);
                      }}
                    >
                      <Text
                        className={classNameNavItem}
                        weight="bold"
                        size="medium"
                        color="white"
                      >
                        {menu?.label}
                      </Text>
                    </span>
                  );
                })}
              </div>

              {!isLogin && pageType !== "registered-user" ? (
                <button
                  className={cn("button-login", isSocSection ? "hidden" : "")}
                  onClick={() => {
                    analytics.sendEvent({ event: "login_pialabyu" });
                    navigate("/login");
                    setShowNavigationMenu(false);
                  }}
                >
                  <img
                    src={func.getStaticImg(`icon/credential.svg`)}
                    alt={"login-icon"}
                    className={"navbar__container__m-button--icon"}
                    height={16}
                    width={16}
                  />
                  <span style={{ marginLeft: "8px" }}>Login</span>
                </button>
              ) : (
                <button
                  className="button-logout"
                  onClick={() => {
                    localStorage.clear();
                    window.location.reload();
                    window.location.href = "/";
                  }}
                >
                  <img
                    src={func.getStaticImg(`icon/sa-logout.svg`)}
                    alt={"logout-icon"}
                    className={"navbar__container__m-button--icon"}
                    id="logout-icon"
                    height={16}
                    width={16}
                  />
                  <span style={{ marginLeft: "8px" }}>Logout</span>
                </button>
              )}
            </div>

            {renderNav()}
            {!isMobileView && !isShowBurger && !isLogin ? (
              <Button
                className={cn(
                  "navbar__container__d-button--ticket button-icon-login",
                )}
                variant={getStyles()?.loginbtn}
                size={"small"}
                onClick={() => {
                  analytics.sendEvent({ event: "login_pialabyu" });
                  navigate("/login");
                  setShowNavigationMenu(false);
                }}
              >
                <span style={{ display: "inline-flex", alignItems: "center" }}>
                  <img
                    src={func.getStaticImg(
                      `icon/credential-${getStyles()?.iconLogin}.svg`,
                    )}
                    alt={"login-icon"}
                    className={"navbar__container__m-button--icon icon-login"}
                    height={16}
                    width={16}
                    style={{ marginRight: 8 }}
                  />
                  Login
                </span>
              </Button>
            ) : isLogin ? (
              <div
                className={`md:mr-[10%] mr-4 flex align-middle items-center gap-2 ${
                  location.pathname !== "/" &&
                  location.pathname !== "/pembayaran"
                    ? "ml-auto"
                    : "ml-0"
                }`}
              >
                <img
                  src={imgLogo}
                  alt={`school-logo`}
                  onClick={() =>
                    navigate(city === "soc" ? buildURLWithParams("/") : "/")
                  }
                  className={"h-[28px] w-[28px] navbar__container__byu-logo"}
                />

                {(location.pathname === "/" ||
                  location.pathname === "/pembayaran" ||
                  (location.pathname === "/main" && !isMobileView)) && (
                  <span
                    className={`font-bold text-[16px] truncate max-w-[128px] ${
                      location.pathname !== "/" &&
                      location.pathname !== "/pembayaran"
                        ? "text-white"
                        : "text-black"
                    }`}
                  >
                    {registrationData?.school_name || "-"}
                  </span>
                )}
              </div>
            ) : idInView === "rsvp" ? null : (
              <img
                src={func.getStaticImg(
                  `icon/credential-${getStyles()?.iconLogin}.svg`,
                )}
                alt={"login-icon"}
                onClick={() => {
                  analytics.sendEvent({ event: "login_pialabyu" });
                  navigate("/login");
                  setShowNavigationMenu(false);
                }}
                className={cn(
                  "h-[24px] w-[24px]  navbar__container__byu-logo ml-auto md:mr-[10%] mr-4",
                )}
              />
            )}

            {/* button pendaftaran */}
            {/* {idInView?.includes("home-detail") &&
            isRegist &&
            !isMobileView &&
            !isShowBurger && (
              <Button
                className={"navbar__container__d-button--ticket"}
                variant={"primary-orange"}
                size={"small"}
                onClick={() => window.open(registrationUrl, "_blank")}
              >
                <span style={{ marginLeft: "8px" }}>PENDAFTARAN</span>
              </Button>
            )} */}

            {isShowBurger && !isGalleryPage && idInView !== "rsvp" && (
              <button
                className="navbar__burger-menu"
                type="button"
                onClick={handleNavigationMenu}
              >
                <span className={classNamesBurger}></span>
                <span className={classNamesBurger}></span>
                <span className={classNamesBurger}></span>
              </button>
            )}
          </div>
        )}
      </div>
    </>
  );
};

NavBar.propTypes = {
  menus: PropTypes.array,
  className: PropTypes.string,
};

NavBar.defaultProps = {
  menus: "",
  className: "",
};

export default NavBar;
